export default __webpack_public_path__ + "static/media/work_portfolio_form.c2bb405e.jpg";